import {
  reportSchema,
  safetyAlertSchema,
  type AlertListQuery,
  type CreateReportInput,
  type Page,
  type RaiseAlertInput,
  type Report,
  type ReportListQuery,
  type SafetyAlert,
} from '@teentack/shared';
import { post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

export async function createReport(input: CreateReportInput): Promise<Report> {
  return reportSchema.parse(await post<unknown>('/safety/reports', input));
}

export function fetchMyReports(query: Partial<ReportListQuery> = {}): Promise<Page<Report>> {
  return fetchPage('/safety/reports', reportSchema, query);
}

export async function raiseAlert(input: RaiseAlertInput): Promise<SafetyAlert> {
  return safetyAlertSchema.parse(await post<unknown>('/safety/alerts', input));
}

export function fetchMyAlerts(query: Partial<AlertListQuery> = {}): Promise<Page<SafetyAlert>> {
  return fetchPage('/safety/alerts', safetyAlertSchema, query);
}
